module.exports = __webpack_public_path__ + "img/level6-3.98ac1af7.png";